import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import DescriptionIcon from "@mui/icons-material/Description";
import {
  backgroundColor,
  blackShade19,
  blackShade28,
  blueColor04,
  greenShade16,
  greyColor33,
  greyColor40,
  greyColor58,
  whiteColor,
} from "../../configs/styles/muiThemes";
import DateSearchFilterWithlabel from "../OrderReports/PopupCard/DateSearchFilterWithlabel";
import MonthYearRangeSelector from "../../components/Input/MonthYearRangeSelector";
import MonthYearPicker from "../../components/Input/MonthYearPicker";
import moment from "moment";

function ReportTile({
  title,
  onDownload,
  hideBorder,
  data,
  setData,
  error,
  loader,
  monthYearPicker,
  subTitle,
  infoText,
  bottomInfoText,
  customFont,
}) {
  const handleDateChange = (newValue) => {
    setData((prev) => ({
      ...prev,
      ...newValue,
    }));
  };
  return (
    <Box
      sx={{
        display: "flex",
        p: "14px",
        borderBottom: hideBorder ? "" : "1px solid " + greyColor58,
        alignItems: "center",
      }}
    >
      <Typography
        fontSize={14}
        fontWeight={600}
        color={blackShade19}
        lineHeight="30px"
        flex={1.5}
      >
        {title}
      </Typography>
      <Stack flex={3}>
        <Typography
          fontSize={customFont || 12}
          fontWeight={600}
          color={blackShade28}
          lineHeight={1}
          flex={1}
        >
          {subTitle ? (
            <>
              {subTitle}{" "}
              <strong style={{ color: blueColor04, marginLeft: 1 }}>
                {moment().format("Do MMM YYYY")}
              </strong>
            </>
          ) : (
            title
          )}
          {infoText && (
            <Typography
              component="span"
              fontSize={11.5}
              fontWeight={400}
              color={greyColor40}
              lineHeight={1}
            >
              {"  "}({infoText})
            </Typography>
          )}
        </Typography>
        {!subTitle && (
          <Box width="80%">
            {!monthYearPicker && (
              <DateSearchFilterWithlabel
                gap="30px"
                hideLabel
                mb="0"
                data={{ from: data?.from, to: data?.to }}
                setSearchValues={(newRange) =>
                  setData((prev) => ({
                    ...prev,
                    from: newRange?.from,
                    to: newRange?.to,
                  }))
                }
              />
            )}

            {monthYearPicker && (
              <MonthYearPicker
                value={data}
                onChange={handleDateChange}
                mt="10px"
              />
            )}
            {error ? (
              <Typography
                variant="subtitle1"
                component="p"
                fontSize={12}
                fontWeight={500}
                color="red"
                textAlign={"start"}
                mt={1}
              >
                {error}
              </Typography>
            ) : null}
          </Box>
        )}

        {bottomInfoText && (
          <Typography
            fontSize={11.5}
            fontWeight={400}
            color={greyColor40}
            lineHeight={1}
            mt={1.5}
          >
            {bottomInfoText}
          </Typography>
        )}
      </Stack>
      <Box
        flex={1}
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "flex-end",
          flexDirection: "column",
        }}
      >
        {/* {error ? (
          <Typography
            variant="subtitle1"
            component="p"
            fontSize={12}
            fontWeight={500}
            color="red"
            textAlign={"end"}
            mb={1}
          >
            {error}
          </Typography>
        ) : null} */}
        <Button
          sx={styles.actionBtn}
          disabled={loader}
          endIcon={<DescriptionIcon />}
          onClick={onDownload}
        >
          Download To Excel
        </Button>
      </Box>
    </Box>
  );
}

export default ReportTile;

const styles = {
  actionBtn: {
    fontSize: 11,
    fontWeight: 600,
    lineHeight: "22px",
    color: greenShade16,
    border: `1px solid ${greenShade16}`,
    backgroundColor: whiteColor,
    p: "6px 14px",
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: greenShade16,
      color: whiteColor,
    },
    "&:disabled": {
      border: `1px solid ${greyColor33}`,
      opacity: 0.6,
    },
  },
};
